export default __webpack_public_path__ + "nagorik-songbad-colored.png";